import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseAppState } from '../../../core/store/reducers';
import { USER_UI_PATH_ELEMENTS } from '../../users/definitions/user-ui-navigation.definitions';
import { AuthSelectors } from '../selectors/auth.selectors';

@Injectable()
export class LoggedOutGuard implements CanActivate {
  private readonly isLoggedIn$ = this.store.pipe(select(AuthSelectors.isLoggedIn));

  constructor(private readonly router: Router, private readonly store: Store<BaseAppState>) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.isLoggedIn$.pipe(
      map((loggedIn) => {
        if (!loggedIn) {
          return true;
        }
        const redirectUrlTree = this.router.createUrlTree([
          `/${USER_UI_PATH_ELEMENTS.rootElement}`,
        ]);
        return redirectUrlTree;
      })
    );
  }
}
